import { render, staticRenderFns } from "./JobSeekersOthers.vue?vue&type=template&id=7244f2fa&scoped=true&"
import script from "./JobSeekersOthers.vue?vue&type=script&lang=js&"
export * from "./JobSeekersOthers.vue?vue&type=script&lang=js&"
import style0 from "./JobSeekersOthers.vue?vue&type=style&index=0&id=7244f2fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7244f2fa",
  null
  
)

export default component.exports